import React, { useState, useEffect } from 'react'
import {
  Table,
  IconButton,
  Icon,
  Panel,
  ButtonGroup,
  Row,
  Col,
  Dropdown,
  SelectPicker,
  Input,
  Button,
  DatePicker,
  CheckPicker,
  Modal,
  ControlLabel,
} from 'rsuite'
import { useHistory } from 'react-router-dom'
import SearchButton from '../../components/buttons/searchButton/SearchButton'
import CancelButton from '../../components/buttons/cancelButton/CancelButton'
import { DATE_FORMAT } from '../../constants/date'
import moment from 'moment'
import { budgetFormat } from '../../utils/formatterUtil'
import ViewButton from '../../components/buttons/viewButton/ViewButton'
import TablePagination from 'rsuite/lib/Table/TablePagination'
import SaveButton from '../../components/buttons/saveButton/SaveButton'
import InputForm from '../../components/forms/input/InputForm'
import { useForm, Controller } from 'react-hook-form/dist/index.ie11'
import { color } from 'echarts'
import ErrorMessage from '../../components/message/errorMessage/ErrorMessage'
import classNames from 'classnames'
import { isRequired, isValidators } from '../../utils/ValidatorUtils'

export default function CheckProjectQualityTable({
  schema,
  loading,
  onSelect = () => {},
  onSearch = () => {},
  onCancel = () => {},
  page = 1,
  displayLength = 5,
  defaultLengthMenu = [
    { value: 5, label: 5 },
    { value: 10, label: 10 },
    { value: 15, label: 15 },
  ],
  onReload = () => {},
  handleOnSubmit = () => {},
  // register,
  // control,
  // handleSubmit = () => {},
  // errors,
  // getValues,
  // setValue,
  // setError,
  // clearErrors,
  addComment,
  setAddComment = () => {},
  setModalSubProjectCode = () =>{},
  ...props
}) {
  const { Column, HeaderCell, Cell } = Table
  const { register, handleSubmit, errors, control, setValue, getValues, clearErrors } = useForm()
  const history = useHistory()
  const [tableData, setTableData] = useState([])
  const [txtProjectCodeVal, SetTxtprojectCodeVal] = useState('')
  const [txtSubProjectCodeVal, SetTxtsubProjectCodeVal] = useState('')

  useEffect(() => {
    setTableData(schema?.data?.values || [])
  }, [schema])
  console.log('errors', errors)

  const handleSearch = () => {
    // console.log('handleSearch ')
    var req = {
      projectCode: txtProjectCodeVal,
      subProjectCode: txtSubProjectCodeVal,
    }
    onSearch(displayLength, page, req)
  }

  const handleCancel = () => {
    SetTxtprojectCodeVal('')
    SetTxtsubProjectCodeVal('')
    onCancel(displayLength, 1)
  }

  const handleChangeLength = (dataKey) => {
    onReload(1, dataKey)
  }

  const handleChangePage = (dataKey) => {
    onReload(dataKey, displayLength)
  }

  const onSubmit = (data) => {
    console.log('data', data)

    // let request = {
    //   projectCode: projectCode,
    //   comment: data.projectComments,
    //   mentorLevel: data.nannyQualityLevel,
    //   projectLevel: data.projectQualityLevel,
    // }
    handleOnSubmit(data)
  }

  // console.log('tableData ', tableData)

  return (
    <>
      {schema?.searchForm && (
        <Panel bordered header={'ค้นหา'} collapsible defaultExpanded>
          <div style={{ marginTop: -10, marginBottom: -10 }}>
            <Row style={{ marginBottom: 10 }}>
              <Col lg={4} md={4} sm={24} xs={24}></Col>
              <Col lg={8} md={8} sm={24} xs={24}>
                {schema.searchForm.projectCode.label}
                <Input
                  value={txtProjectCodeVal}
                  onChange={(value) => {
                    SetTxtprojectCodeVal(value)
                  }}
                />
              </Col>

              <Col lg={8} md={8} sm={24} xs={24}>
                {schema.searchForm.subProjectCode.label}
                <Input
                  value={txtSubProjectCodeVal}
                  onChange={(value) => {
                    SetTxtsubProjectCodeVal(value)
                  }}
                />
              </Col>
              <Col lg={4} md={4} sm={24} xs={24}></Col>
            </Row>

            <Row style={{ marginBottom: 10 }}>
              <Col lg={4} md={4} sm={24} xs={24}></Col>
              <Col lg={8} md={8} sm={24} xs={24}>
                <SearchButton disabled={false} onClick={handleSearch}>
                  ค้นหา
                </SearchButton>
                <CancelButton disabled={false} onClick={handleCancel}>
                  ยกเลิก
                </CancelButton>
              </Col>
            </Row>
          </div>
        </Panel>
      )}

      <Table
        wordWrap
        // height={350}
        // autoHeight={tableData.length < 10}
        minHeight={350}
        autoHeight
        loading={loading}
        data={tableData}
        style={{ marginTop: 10 }}
      >
        <Column width={90} align="center">
          <HeaderCell>ลำดับ</HeaderCell>
          <Cell>
            {(_, index) => {
              // return index + 1
              return (page - 1) * displayLength + index + 1
            }}
          </Cell>
        </Column>

        <Column width={150}>
          <HeaderCell>รหัสโครงการหลัก</HeaderCell>
          <Cell dataKey="projectCode" />
        </Column>
        <Column width={150}>
          <HeaderCell>รหัสโครงการย่อย</HeaderCell>
          <Cell dataKey="subProjectCode" />
        </Column>
        <Column width={180}>
          <HeaderCell>ระดับคุณภาพโครงการ</HeaderCell>
          <Cell dataKey="projectQualityLevel">
            {(rowData) => {
              const qualityLevel = rowData.projectQualityLevel
              let color, label

              switch (qualityLevel) {
                case 1:
                  color = '#2da888'
                  label = 'ดีมาก'
                  break
                case 2:
                  color = '#ffc489'
                  label = 'ดี'
                  break
                case 3:
                  color = '#fb8a81'
                  label = 'ควรปรับปรุง'
                  break
                default:
                  color = '#5e5e5e'
                  label = 'ไม่มีข้อมูล'
              }

              return (
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <span
                    style={{
                      color: color,
                      fontSize: '12px',
                      lineHeight: 1,
                    }}
                  >
                    <Icon icon="circle" />
                  </span>
                  <span>{label}</span>
                </div>
              )
            }}
          </Cell>
        </Column>

        <Column width={180}>
          <HeaderCell>ระดับคุณภาพพี่เลี้ยง</HeaderCell>
          <Cell dataKey="nannyQualityLevel">
            {(rowData) => {
              const qualityLevel = rowData.nannyQualityLevel
              let color, label

              switch (qualityLevel) {
                case 1:
                  color = '#2da888'
                  label = 'ดีมาก'
                  break
                case 2:
                  color = '#ffc489'
                  label = 'ดี'
                  break
                case 3:
                  color = '#fb8a81'
                  label = 'ควรปรับปรุง'
                  break
                default:
                  color = '#5e5e5e'
                  label = 'ไม่มีข้อมูล'
              }

              return (
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <span
                    style={{
                      color: color,
                      fontSize: '12px',
                      lineHeight: 1,
                    }}
                  >
                    <Icon icon="circle" />
                  </span>
                  <span>{label}</span>
                </div>
              )
            }}
          </Cell>
        </Column>
        <Column width={250}>
          <HeaderCell>ชื่อโครงการย่อย </HeaderCell>
          <Cell dataKey="subProjectName" />
        </Column>

        <Column width={200}>
          <HeaderCell>ผู้ให้ความเห็น</HeaderCell>
          <Cell dataKey="commentator" />
        </Column>

        <Column width={250}>
          <HeaderCell>ความเห็นต่อโครงการล่าสุด</HeaderCell>
          <Cell dataKey="latestProjectComments" />
        </Column>

        <Column width={320} align="center" fixed="right">
          <HeaderCell>จัดการ</HeaderCell>
          <Cell>
            {(rowData) => {
              // console.log('file ', rowData)
              // disabled={!rowData.pathFile} เช็คกรณีที่ pathFile = null
              return (
                <>
                  <SaveButton
                    icon="plus-square-o"
                    onClick={() => {
                      setAddComment(true)
                      setModalSubProjectCode(rowData.subProjectCode)
                    }}
                  >
                    เพิ่มความคิดเห็น
                  </SaveButton>
                  <ViewButton
                    icon="eye"
                    onClick={() => onSelect(rowData)}
                    style={{ marginBottom: '10px' }}
                  >
                    ดูประวัติ
                  </ViewButton>
                </>
              )
            }}
          </Cell>
        </Column>
      </Table>
      <TablePagination
        lengthMenu={defaultLengthMenu}
        activePage={page}
        renderLengthMenu={(lengthMenu) => {
          return (
            <>
              {lengthMenu}
              {`รายการ/หน้า`}
            </>
          )
        }}
        renderTotal={(total) => {
          return <>{` ทั้งหมด ${total} รายการ`}</>
        }}
        displayLength={displayLength || 5}
        total={schema?.data?.totalSize || 0}
        onChangePage={handleChangePage}
        onChangeLength={handleChangeLength}
      />

      {/* เพิ่มความคิดเห็น */}
      <Modal
        show={addComment}
        onHide={() => {
          // setShowVerifyConfirm(false)
          // setShowTransferInstallmentPaymentConfirm(false)
          setAddComment(false)
        }}
        size="lg"
      >
        <Modal.Header>
          <Modal.Title>
            {/* {schemas?.forms?.buttonRequestInstallmentPayment?.header || ''} */}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {schema.searchForm && (
            <>
              <Row style={{ marginTop: 20 }}>
                <Col lg={24} md={24} sm={20} xs={20}>
                  {/* {schema.searchForm.projectQualityLevel.label} */}
                  <ControlLabel
                    className={classNames(
                      isRequired(schema.searchForm.projectComments.validators) && 'required'
                    )}
                  >
                    {schema.searchForm.projectComments.label}
                  </ControlLabel>
                  <ErrorMessage error={errors.urbanType} />
                
                  <InputForm
                    schema={schema.searchForm.projectComments}
                    // value={item.link}
                    register={register}
                    // placeholder={formSchema.otherExpensesInput.placeholder}
                    Controller={Controller}
                    control={control}
                    errors={errors}
                    setValue={setValue}
                    clearErrors={clearErrors}
                    hideLabel={true}
                    componentClass={'textarea'}
                    rows={10}
                  />
                </Col>
              </Row>
              <Row style={{ marginTop: 20 }}>
              <ErrorMessage error={errors.projectQualityLevel} />
                <Col lg={5} md={5} sm={5} xs={5}>
                  {/* {schema.searchForm.projectQualityLevel.label} */}
                  <ControlLabel
                    className={classNames(
                      isRequired(schema.searchForm.projectQualityLevel.validators) && 'required'
                    )}
                  >
                    {schema.searchForm.projectQualityLevel.label}
                  </ControlLabel>
                  
                </Col>
                <Col lg={19} md={19} sm={19} xs={19}>
                
                  <Controller
                    name={schema.searchForm.projectQualityLevel.name}
                    control={control}
                    defaultValue={schema.searchForm.projectQualityLevel.value}
                    rules={isValidators(schema.searchForm.projectQualityLevel.validators)}
                    render={(props) => {
                      return (
                        <SelectPicker
                          data={schema.searchForm.projectQualityLevel.options}
                          // disabled={disabledValue.toBudgetYear}
                          value={props.value}
                          searchable={false}
                          block
                          placeholder={`เลือก${schema.searchForm.projectQualityLevel.label}`}
                          onChange={(value) => {
                            props.onChange(value)
                          }}
                        />
                      )
                    }}
                  />
                </Col>
              </Row>
              <Row style={{ marginTop: 20 }}>
              <ErrorMessage error={errors.nannyQualityLevel} />
                <Col lg={5} md={5} sm={5} xs={5}>
                  {/* {schema.searchForm.nannyQualityLevel.label} */}
                  <ControlLabel
                    className={classNames(
                      isRequired(schema.searchForm.nannyQualityLevel.validators) && 'required'
                    )}
                  >
                    {schema.searchForm.nannyQualityLevel.label}
                  </ControlLabel>
                  
                </Col>
                <Col lg={19} md={19} sm={19} xs={19}>
                
                  <Controller
                    name={schema.searchForm.nannyQualityLevel.name}
                    control={control}
                    defaultValue={schema.searchForm.nannyQualityLevel.value}
                    rules={isValidators(schema.searchForm.nannyQualityLevel.validators)}
                    render={(props) => {
                      return (
                        <SelectPicker
                          data={schema.searchForm.nannyQualityLevel.options}
                          // disabled={disabledValue.toBudgetYear}
                          value={props.value}
                          searchable={false}
                          block
                          placeholder={`เลือก${schema.searchForm.nannyQualityLevel.label}`}
                          onChange={(value) => {
                            props.onChange(value)
                          }}
                        />
                      )
                    }}
                  />
                </Col>
              </Row>
            </>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button
            onClick={handleSubmit(onSubmit)}
            appearance="primary"
          >
            ยืนยัน
          </Button>
          <Button
            onClick={() => {
              setAddComment(false)
            }}
            appearance="subtle"
            style={{ backgroundColor: '#EEB187', color: '#fff' }}
          >
            ยกเลิก
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  )
}
